/**
 * Created by ganlu on 28/09/2016.
 */
import template from './original-article.html';
import controller from './original-article.controller';
import './original-article.scss';

let originalArticleComponent = {
    restrict: 'E',
    bindings: {
        'article': '=',
        'appUser': '=',
        'setError': '&',
        'setReproduction': '&',
        'setShowReproductionDetail': '&',
        'shareToWeixin': '&',
        'hideBottomBar': '='
    },
    template,
    controller
};

export default originalArticleComponent;



// WEBPACK FOOTER //
// ./src/app/components/page/original/original-article/original-article.component.js